import React from 'react';
import SetInnerHTML from '../../../../../UI/SetInnerHTML/SetInnerHTML';

export class HorizontalDescriptionEspot extends React.Component {
  render() {
    return (
      <div className='espotWrapper' id='horizontalDescriptionEspot'>
        <div className='overlay'></div>
        {
          <SetInnerHTML
            innerHTML={this.props.contentData.ES_Horizontal_Description}
            espotname='ES_Horizontal_Description'
          />
        }
      </div>
    );
  }
}

export default HorizontalDescriptionEspot;
